module.exports = __webpack_public_path__ + "files/buetti-cvp.2f1b1f06baa242944e7c428a5da751e7.pdf";